export class IntervalTimer {
  callbackStartTime = 0;
  remaining = 0;
  paused = false;
  timerId: ReturnType<typeof setInterval> | undefined;

  private resumeTimeoutId: ReturnType<typeof setTimeout> | undefined;
  private nextRunAt = 0;
  private _callback: () => void;
  private _delay: number;

  constructor(callback: () => void, delay: number) {
    this._callback = callback;
    this._delay = delay;
    this.remaining = delay;
  }

  reset(callback: () => void, delay: number) {
    this.clear();
    this.callbackStartTime = 0;
    this.remaining = delay;
    this.paused = false;
    this._callback = callback;
    this._delay = delay;
  }

  pause() {
    if (this.paused) {
      if (this.resumeTimeoutId !== undefined) {
        clearTimeout(this.resumeTimeoutId);
        this.resumeTimeoutId = undefined;
      }
      return;
    }

    const now = Date.now();
    this.remaining = this.nextRunAt > now ? this.nextRunAt - now : this._delay;
    this.clear();
    this.paused = true;
  }

  resume() {
    if (!this.paused || this.resumeTimeoutId !== undefined) return;

    const waitMs = Math.max(0, this.remaining || this._delay);
    this.resumeTimeoutId = setTimeout(() => {
      this.resumeTimeoutId = undefined;
      if (!this.paused) return;

      this.paused = false;
      this.run();
      this.startInterval();
    }, waitMs);
  }

  clear() {
    if (this.timerId !== undefined) clearInterval(this.timerId);
    if (this.resumeTimeoutId !== undefined) clearTimeout(this.resumeTimeoutId);
    this.timerId = undefined;
    this.resumeTimeoutId = undefined;
    this.nextRunAt = 0;
  }

  start() {
    this.clear();
    this.paused = false;
    this.remaining = this._delay;
    this.startInterval();
  }

  run() {
    this.callbackStartTime = Date.now();
    this._callback();
  }

  private startInterval() {
    this.nextRunAt = Date.now() + this._delay;
    this.timerId = setInterval(() => {
      this.run();
      this.nextRunAt = Date.now() + this._delay;
    }, this._delay);
  }
}
